import { render, staticRenderFns } from "./GBModalVScrollable.vue?vue&type=template&id=55f74f76&scoped=true&"
import script from "./GBModalVScrollable.vue?vue&type=script&lang=js&"
export * from "./GBModalVScrollable.vue?vue&type=script&lang=js&"
import style0 from "./GBModalVScrollable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBModalVScrollable.vue?vue&type=style&index=1&id=55f74f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f74f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
